
import { mapState, mapActions, mapGetters } from 'vuex';
import BoxHourlyMixChart from '../components/Box/BoxHourlyMixChart';

export default {
  data() {
    return {
      showGenerateWidget: false,
      clickedStore: {},
      hourly: [],
      daily: [],
      series: [],
      series2: [],
      overviewData: [],
      dailyLoading: true,
      hourlyLoading: true,
      isConfigLoading: false,
      scrolled: false
    };
  },
  computed: {
    ...mapState('occupancy', [
      'selectedStore',
      'overview',
      'hourlyData',
      'hourlyCategories',
      'dailyData',
      'dailyCategories',
      'hourlyLoadingState',
      'dailyLoadingState'
    ]),
    ...mapGetters('filter', [
      'getStoreCodesList',
      'getDaysOfWeekList',
      'getStartingPeriod',
      'getEndingPeriod'
    ])
  },
  watch: {
    async getDaysOfWeekList() {
      await this.fetchOccupancyOverview();
      this.dailyLoading = true;
      let data = {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        storeCodes:
          typeof this.selectedStore === 'object'
            ? this.selectedStore.storeCode
            : this.selectedStore,
        daysOfWeek: this.getDaysOfWeekList,
        storeId: this.selectedStore.id
      };

      this.fetchDailyData(data);
    },
    // currentWidgetToken(newValue) {
    //   this.setHourlyDataFromSocket(newValue); // here..
    // },
    hourlyLoadingState(newValue) {
      this.hourlyLoading = newValue;
    },
    dailyLoadingState(newValue) {
      this.dailyLoading = newValue;
    },
    overview() {
      this.overviewData = this.overview;
    },
    hourlyData() {
      this.series = this.hourlyData ?? [];
      this.hourly = this.hourlyCategories ?? [];
      // this.hourlyLoading = false;
    },
    dailyData() {
      this.series2 = this.dailyData ?? [];
      this.daily = this.dailyCategories ?? [];
      // this.dailyLoading = false;
    },
    async getStoreCodesList() {
      let data = {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        storeCodes: this.getStoreCodesList,
        daysOfWeek: this.getDaysOfWeekList,
        storeId: this.selectedStore.id
      };
      // await this.fetchHourlyData(data);
      await this.fetchOccupancyOverview();
    },
    async selectedStore() {
      // var result = await this.fetchStoreSensors();
      // var sensorIdSelectedStore = result._id
      // call getsensordata api
      let data = {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        // storeCodes:
        //   typeof this.selectedStore === 'object'
        //     ? this.selectedStore.storeCode
        //     : this.selectedStore,
        daysOfWeek: this.getDaysOfWeekList,
        storeId: this.selectedStore.id,
        // sensorid
        capacityMax: this.selectedStore.capacity,
    };

    localStorage.setItem("MaxConfigOccupancy",data?.capacityMax);
    delete data?.capacityMax;

      this.fetchHourlyData(data);
      this.fetchDailyData(data);
      this.fetchPowerHourData(data);
    },
    async getStartingPeriod() {
      this.dailyLoading = true;
      await this.fetchOccupancyOverview();
      let data = {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        // storeCodes:
        //   typeof this.selectedStore === 'object'
        //     ? this.selectedStore.storeCode
        //     : this.selectedStore,
        daysOfWeek: this.getDaysOfWeekList,
        storeId: this.selectedStore.id
      };
      this.fetchDailyData(data);
      this.fetchPowerHourData(data);
      this.fetchHourlyData(data);
    },
    async getEndingPeriod() {

      this.dailyLoading = true;
      await this.fetchOccupancyOverview();
      let data = {
        startDate: this.getStartingPeriod,
        endDate: this.getEndingPeriod,
        // storeCodes:
        //   typeof this.selectedStore === 'object'
        //     ? this.selectedStore.storeCode
        //     : this.selectedStore,
        daysOfWeek: this.getDaysOfWeekList,
        storeId: this.selectedStore.id
      };
      this.fetchDailyData(data);
      this.fetchPowerHourData(data);
      this.fetchHourlyData(data);
    }
  },
  async created() {
    await this.fetchOccupancyOverview();
    let data = {
      startDate: this.getStartingPeriod,
      endDate: this.getEndingPeriod,
      storeCodes:
        typeof this.selectedStore === 'object'
          ? this.selectedStore.storeCode
          : this.selectedStore,
      daysOfWeek: this.getDaysOfWeekList,
      storeId: this.selectedStore.id
    };

    // await this.fetchHourlyData(data);
    // await this.fetchDailyData(data);
    // await this.fetchPowerHourData(data);
    // await this.fetchToken({ storeCodes: this.selectedStore.storeCode });
    //this.socketOccupancyOverview(); // here..
    this.hourlyLoading = this.hourlyLoadingState;
    },
    methods: {
    refreshPage() {
      this.lastTimeStamp = Date.now();
    },
    // setHourlyDataFromSocket(token) {
//   const client = webstomp.client('wss://eddy-api.flow-insight.com/socket');
//   const client = webstomp.client('wss://eddy-api.flow-insight.com/socket');
    //   const decodedMsg = this.decodeToken(token);
    //   const {
    //     authKey,
    //     authSecret,
    //     tenant,
    //     storeCode,
    //     accessLevel
    //   } = decodedMsg;
    //   client.connect(
    //     {
    //       tenant,
    //       authKey,
    //       authSecret,
    //       accessLevel,
    //       storeCode
    //     },
    //     () => {
    //       this.loading = false;
    //       client.subscribe(`/queue/${tenant}/${storeCode}`, frame => {
    //         if (frame.body) {
    //           let occupancy = JSON.parse(frame.body);
    //           this.socketHourlySeries(occupancy.hourlyOccupancy); // here..
    //           this.socketHourlyCategory(occupancy.hourlyOccupancy); // here..
    //         }
    //       });
    //     }
    //   );
    //   client.disconnect(() => {
    //     this.resetOccupancy();
    //     this.hourlyData = [];
    //   });
    // },
    // decodeToken(token) {
    //   const payload = Buffer.from(token, 'base64');
    //   return JSON.parse(payload);
    // },
    async setSelectedStore(storeData) {
      this.isConfigLoading = true;
      this.clickedStore = storeData;
      // this.fetchToken({ storeCodes: storeData.storeCode });
      //Nabeel
      //await this.fetchEddyConfig(storeData.storeCode);
      await this.fetchEddyConfig(storeData);
      this.isConfigLoading = false;
    },
    handleScroll(evt, el) {
      if (window.scrollY > 10) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    toggleGenerateWidget(value) {
      this.showGenerateWidget = value;
    },
    ...mapActions('occupancy', [
      // 'fetchToken',
      'fetchOccupancyOverview',
      'fetchHourlyData',
      'fetchDailyData',
      // 'fetchStoreSensors',
      'fetchPowerHourData',
      'socketOccupancyOverview', // here..
       'fetchEddyConfig',
      'socketHourlySeries', // here..
      'socketHourlyCategory' // here..
    ])
  }
};
